export default "__VITE_ASSET__9d81e8ae__"